import config from 'config/app'
import moment from 'moment'

import {
  CURRENT_USER_REQUEST_ERROR,
  CURRENT_USER_REQUEST_SUCCESS,
  CURRENT_USER_FETCHING,

  ATTEND_SUCCESS,
  ATTEND_ERROR,
  IS_ATTENDING,

  BUY_SUCCESS,
  BUY_ERROR,
  IS_BUYING,

  CLAIM_SUCCESS,
  CLAIM_ERROR,
  IS_CLAIMING,

  EXCHANGE_SUCCESS,
  EXCHANGE_ERROR,
  IS_EXCHANGING,

  GET_HISTORY_SUCCESS,
  GET_HISTORY_ERROR,
  IS_GETTING_HISTORY
} from './actions'

const initialState = {
  loading: false,
  login: false,
  days: [],
  dailyReward: [],
  stages: [],
  stageReward: [],
  configId: null,
  currentTime: null,
  endTime: null,
  exchanges: [],
  buy: {},
  token: 0,
  histories: [],
  deltaTime: 0,
  isAttending: false,
  isBuying: false,
  isClaiming: false,
  isExchanging: false,
  isGettingHistory: false
}

export default function currentUserReducer(state = initialState, action) {
  switch (action.type) {
    case CURRENT_USER_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        login: true,
        errorGlobal: '',
        days: action.payload.daily_config,
        dailyReward: action.payload.daily_reward,
        stages: action.payload.stage_config,
        stageReward: action.payload.stage_reward,
        exchanges: action.payload.exchange_config,
        configId: action.payload.config_id,
        currentTime: action.payload.current_datetime,
        endTime: action.payload.end_time,
        buy: action.payload.buy,
        token: action.payload.user_token,
        deltaTime: moment(action.payload.current_datetime) - moment()
      }
      break;
    case CURRENT_USER_REQUEST_ERROR:
      return {
        ...state,
        loading: false,
        errorGlobal: 'Không có thông tin user'
      }
      break;
    case CURRENT_USER_FETCHING:
      return {
        ...state,
        loading: true
      }
      break;

    //ATTEND
    case ATTEND_SUCCESS:
      return {
        ...state,
        isAttending: false,
        dailyReward: action.payload.daily_reward,
        token: action.payload.user_token
      }
      break;
    case ATTEND_ERROR:
      return {
        ...state,
        isAttending: false,
        errorGlobal: action.payload
      }
      break;
    case IS_ATTENDING:
      return {
        ...state,
        isAttending: true
      }
      break;

    //ATTEND
    case BUY_SUCCESS:
      return {
        ...state,
        isBuying: false,
        dailyReward: action.payload.daily_reward,
        token: action.payload.user_token
      }
      break;
    case BUY_ERROR:
      return {
        ...state,
        isBuying: false,
        errorGlobal: action.payload
      }
      break;
    case IS_BUYING:
      return {
        ...state,
        isBuying: true
      }
      break;

    //ATTEND
    case CLAIM_SUCCESS:
      return {
        ...state,
        isClaiming: false,
        stageReward: action.payload.stage_reward,
        token: action.payload.user_token
      }
      break;
    case CLAIM_ERROR:
      return {
        ...state,
        isClaiming: false,
        errorGlobal: action.payload
      }
      break;
    case IS_CLAIMING:
      return {
        ...state,
        isClaiming: action.payload
      }
      break;

    //EXCHANGE
    case EXCHANGE_SUCCESS:
      return {
        ...state,
        isExchanging: false,
        token: action.payload.user_token
      }
      break;
    case EXCHANGE_ERROR:
      return {
        ...state,
        isExchanging: false,
        errorGlobal: action.payload
      }
      break;
    case IS_EXCHANGING:
      return {
        ...state,
        isExchanging: action.payload
      }
      break;
    //EXCHANGE
    case GET_HISTORY_SUCCESS:
      return {
        ...state,
        isGettingHistory: false,
        histories: action.payload.token_history
      }
      break;
    case GET_HISTORY_ERROR:
      return {
        ...state,
        isGettingHistory: false,
        errorGlobal: action.payload
      }
      break;
    case IS_GETTING_HISTORY:
      return {
        ...state,
        isGettingHistory: action.payload
      }
      break;
      
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/authentication/reducer.js